require(['json!mdactions.json', 'angular', 'angularMock', 'angularRoute', 'core', 'lodash'], function (routeInfo, angular, mocks, route, app, _) {
  angular.element(document).ready(function () {
    angular.bootstrap(document, ['core'], {
      strictDi: true
    });
    //console.log('loading angular')
  })
})
;
define("js/app.js", function(){});

